import * as React from 'react';
import { useSelector } from 'react-redux';
import { IBaseButtonProps } from '@cian/ui-kit/button/types';
import { FicheringCall, EPageTypes, EPlatformTypes } from '@cian/frontend-newbuilding-call-component';
import { ApplicationContext } from '../../utils';
import { getDeveloper } from '../../selectors/developerV2';
import { useContacts } from './useContacts';
import { IBuilder } from '@cian/frontend-newbuilding-call-component/es/types/builder';
import { ISeller } from '@cian/frontend-newbuilding-call-component/es/types/seller';

interface ICallProps {
  onShowPhone(developerId: number): void;
  openContactsStyles?: IBaseButtonProps;
  showPhoneStyles?: IBaseButtonProps;
}

export function CallRedesigned({ onShowPhone, openContactsStyles, showPhoneStyles }: ICallProps) {
  const context = React.useContext(ApplicationContext);

  const developer = useSelector(getDeveloper);

  const { builders, sellers } = useContacts();

  const handleShowPhone = React.useCallback(() => {
    onShowPhone(developer.id);
  }, [developer, onShowPhone]);

  return (
    <FicheringCall
      pageType={EPageTypes.NewbuildingCard}
      platformType={EPlatformTypes.WebDesktop}
      placeType="developerCardContacts"
      onShowPhoneClick={handleShowPhone}
      httpApi={context.httpApi}
      logger={context.logger}
      showPhoneStyles={showPhoneStyles}
      openContactsStyles={openContactsStyles}
      builders={builders as IBuilder[]}
      sellers={sellers as ISeller[]}
    />
  );
}
